// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../node_modules/postcss-loader/src/index.js!../../styleGuide.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".src-components-Icon-IconNoteButton__background--3GM4T{fill:" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["primaryColorMedium"] + "}.src-components-Icon-IconNoteButton__svg--3Yr2A:hover .src-components-Icon-IconNoteButton__background--3GM4T{fill:" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["primaryColorLight"] + "}", ""]);
// Exports
exports.locals = {
	"primaryColorMedium": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["primaryColorMedium"] + "",
	"primaryColorLight": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["primaryColorLight"] + "",
	"background": "src-components-Icon-IconNoteButton__background--3GM4T",
	"svg": "src-components-Icon-IconNoteButton__svg--3Yr2A"
};
module.exports = exports;
